export var SELLER_COMPLIANCE_NOTE = "*Some products may also be offered by other sellers. The lowest available price for each product is displayed.";